import * as yup from 'yup'

export const unenrollmentSchema = yup.object({
  utilityProgramId: yup.number().required('Utility program ID is required'),
  deviceSelection: yup
    .object({
      vehicleIds: yup.array().of(yup.number().defined()).default([]),
      chargerIds: yup.array().of(yup.number().defined()).default([]),
      thermostatIds: yup.array().of(yup.number().defined()).default([]),
    })
    .test(
      'at-least-one-device',
      'Please select at least one device to unenroll',
      (value) => {
        const totalSelected =
          value.vehicleIds.length +
          value.chargerIds.length +
          value.thermostatIds.length
        return totalSelected > 0
      },
    ),
  unenrollmentReasons: yup
    .array()
    .of(
      yup.object({
        deviceType: yup.string(),
        reason: yup.string(),
      }),
    )
    .required('Please select a reason for unenrollment'),
  feedback: yup
    .string()
    .required('Feedback is required')
    .min(1, 'Feedback cannot be empty'),
})

export type UnenrollmentValidationSchema = yup.InferType<
  typeof unenrollmentSchema
>

export default unenrollmentSchema
